<script lang="ts">
  import { setContext } from 'svelte';
  import '../../common/i18n/i18n';
  // import "@splidejs/splide/dist/css/themes/splide-default.min.css"
  import ProductDetailsMain from './components/ProductDetailsMain.svelte';

  export let pageConfig: any;
  setContext('direction', pageConfig?.direction);
</script>

<div class="page">
  <!-- <Header /> -->

  <ProductDetailsMain />

  <!-- <AppFooterPage /> -->
</div>

<style lang="scss">
  @import '../../common/styles/vars';
  @import '../common/styles/splide.scss';

  h1 {
    color: $color;
    font-weight: 300;
    font-size: 64px;
  }
</style>
